import { env } from "@/config/env";
import { User } from '@/lib/types/user';
import api from "./axios";

const redirectUri = encodeURIComponent(env.oidcRedirectUri)
export const loginUrl = `${env.loginBaseUrl}/auth/login?redirect_uri=${redirectUri}`

export async function getLoggedUser(): Promise<User> {
    const res = await api.get<User>("/rest/v1/users/me")
    return res.data
}
